// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2ybmc","buttons":"PendingPaymentAlert_buttons__3N4ug"};